// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from PriceCurrentValue.module.scss  */
.PriceCurrentValue-module-Root_2ch {
  font-family: var(--display-font-family);
  font-weight: 600;
  color: var(--price-color-current); }

.PriceCurrentValue-module-lSize_2U6 {
  font-size: var(--price-current-value-font-size-l);
  line-height: var(--price-current-value-line-heigth-l); }

.PriceCurrentValue-module-mSize_272 {
  font-size: var(--price-current-value-font-size);
  line-height: var(--price-current-value-line-heigth); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Price/CurrentValue/PriceCurrentValue.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iCAAiC,EAAE;;AAErC;EACE,iDAAiD;EACjD,qDAAqD,EAAE;;AAEzD;EACE,+CAA+C;EAC/C,mDAAmD,EAAE","sourcesContent":["/*  imported from PriceCurrentValue.module.scss  */\n.PriceCurrentValue-module-Root_2ch {\n  font-family: var(--display-font-family);\n  font-weight: 600;\n  color: var(--price-color-current); }\n\n.PriceCurrentValue-module-lSize_2U6 {\n  font-size: var(--price-current-value-font-size-l);\n  line-height: var(--price-current-value-line-heigth-l); }\n\n.PriceCurrentValue-module-mSize_272 {\n  font-size: var(--price-current-value-font-size);\n  line-height: var(--price-current-value-line-heigth); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
